module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-num",
    attrs: {
      "id": "C2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_vm._v("ARCHMERE AND DELAWARE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Joe spotted the grounds and buildings of Archmere Academy from his back bedroom window in the Brookview Apartments. Some might have thought of Archmere as an odd landmark in the steel town of Claymont, a short distance from the mills that employed many. For Joe, it was the first ornate mansion he had ever seen, and he was fixated, staring at it for hours. Later, he practiced Catholic Youth Organization football on its grounds. “When I was ten, getting to Archmere seemed enough,” Joe later wrote. “I’d sit and stare out my bedroom window and dream of the day I would walk through the front doors and take my spot in that seat of learning.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN30",
      "id": "FT30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That day came, thanks in part to a summer of physical labor on the campus. Tuition was $300 a year, or about $3,200 today. (The school’s actual yearly tuition at the time of this writing is $34,100.)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN31",
      "id": "FT31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Joe was determined to attend, despite the tuition being outside the Bidens’ budget, and he lined up a summer work-study job. From 8:00 a.m. to 4:00 p.m., he washed windows, painted fences and pulled weeds, earning his cherished spot each day."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN32",
      "id": "FT32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Patio, as the school’s main home was originally known, was built by John Jakob Raskob, a financier and businessman. Designed in the Italian Renaissance style by architects Clay McClure and Alexander James Harper of Wilmington, the Patio was based on fifteenth-century Florence residences. Built from Kentucky limestone for an initial estimate of $411,000, it sits on a concrete foundation and features eight limestone chimneys. An interior two-story courtyard was built with a mosaic “A” in the center, surrounded by Corinthian columns and covered by a stained-glass skylight, originally able to be retracted into the third floor. The second floor housed the Raskob family’s bedrooms and servants’ quarters; both his and hers suites contained fireplaces. A garage, also built from limestone, was connected to the house via a tunnel that ran underground; the garage featured a full repair shop, a car wash and laundry, as well as sleeping quarters for servants. Later buildings were added after the Norbertine Order purchased the property in 1932, with the Patio serving as an instructional building, student dorm, teacher housing and location for special occasions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN33",
      "id": "FT33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P21-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Joe, Beau, Hunter and Ashley Biden all attended Archmere Academy, founded as an all-boys boarding school on the former estate of DuPont executive John J. Raskob. "), _c('i', [_vm._v("Rachel Kipp.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Raskob, the Patio was both a monument to its Italian heritage and a home, and the residence was its foremost purpose. In 1917, while the home was being designed and built, Raskob wrote to his architects:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("Please keep in mind that we have a large family of children who are going to grow up in this house and that it is very important to have things in such shape as will result in their always feeling that it is a home and not a cold, formal and stately castle which they would like to get away from.")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN34",
      "id": "FT34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The property bore the name Archmere starting in 1873 upon its purchase by George Troutman, named for an arch that the trees along the Delaware River had formed. Troutman’s daughter sold the seventy-acre property to Raskob after her father’s death for $27,000. The family moved in but found the existing mansion house too small for their family, so they built the Patio.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Raskob was a numbers man in the DuPont organization whose financial genius led him to highly powerful positions leading General Motors and the Democratic Party. Born in New York State, Raskob studied accounting at a local business college. That led him to a steel firm in Nova Scotia, and then he gained employment as a bookkeeper and personal secretary to Pierre S. du Pont. Raskob’s influence allowed him to rise to the position of company treasurer in 1909, after he helped guide the company’s growth to control a majority of black powder and dynamite production in the United States. He later advised the du Ponts to purchase $25 million of GM stock, which led to the auto manufacturer handing over control to DuPont. Raskob was named chairman of the GM finance committee, and created GMAC, making cars affordable for the first time for many Americans."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN35",
      "id": "FT35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" He became a millionaire by age forty."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN36",
      "id": "FT36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After corporate changes, Raskob set his sights on politics and became a chairman of the Democratic Party, helping steer Al Smith’s losing campaign against Herbert Hoover in 1928. (The campaign was run out of Archmere.) He later combined forces with Smith to erect the Empire State Building in New York City and found himself on the losing side of presidential politics in 1932 as a foe of Franklin Delano Roosevelt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Raskob sold the property in 1932, as Archmere was becoming surrounded by new development. The Norbertines, based out of DePere, Wisconsin, met with Raskob at the 1932 Democratic National Convention in Chicago and settled on a price. The new school opened on September 14, 1932, a mere seventy-odd days later."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN37",
      "id": "FT37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Biden later wrote of his entrance to the hallowed halls:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("The bus rolled down past the wrought-iron fence (which gleamed with fresh black paint), through the big stone pillars that formed the front gate, and down the yellow-brick road to Raskob’s mansion where the windows shined in the morning light.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The school was rigorous and Catholic-centered. In his first semester, Joe had two periods of Latin per day. He gasped when he walked into the dark-wood, book-lined library—“I thought I’d died and gone to Yale”—but Archmere also marked a period of intense challenge for Joe over his longtime stutter. Nicknamed “Joe Impedimenta,” he took the test earnestly, standing in front of the mirror in his room and practicing by reciting Yeats and Emerson. By the time of his graduation in 1961, Joe, as senior class president, delivered a welcome to parents and friends without stuttering once. “It was the final confirmation that the stutter was not going to hold me back,” Joe recalled."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN38",
      "id": "FT38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P23-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Archmere name comes from the natural arch formed by trees along the Delaware River. Raskob, a financial genius, was a millionaire by his fortieth birthday. "), _c('i', [_vm._v("Delaware Public Archives.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite working hard, Joe wasn’t a complete grind. “No one would ever accuse him of being an outstanding student,” said Joe’s friend and classmate David Walsh."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN39",
      "id": "FT39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" He was a B student, said later headmaster Michael Marinelli. “He wasn’t the bookworm, but he certainly could gather around people and get things done.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN40",
      "id": "FT40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Joe played football, winning special acclaim for his ability to score. A Wilmington newspaper described his last game thusly: “Halfback Joe Biden, who is high up in the state scoring race, was the standout in his final game. He tallied three touchdowns on runs of 4, 12 and 45 yards.” That senior year team finished the season undefeated."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN41",
      "id": "FT41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" That Archmere football team of 1960 held several reunions at Joe’s houses, in 1985 (twenty-fifth) and 2000 (fortieth)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN42",
      "id": "FT42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were also rumors of Joe streaking through the parking lot."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN43",
      "id": "FT43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Joe spent time looking out for the younger students and once took an underclassman to the prom along with his date. “I’d pick up some freshman who was being razzed and give him a ride home, maybe stop by the Charcoal Pit so he could be seen with me,” he said."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN44",
      "id": "FT44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Joe dated a friend of his sister Valerie’s starting at Archmere and continuing through his sophomore year in college."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN45",
      "id": "FT45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a parent of three children who attended Archmere, Joe was also involved, including helping decorate the gym for prom in 1988. “He was always himself, but when he came here he was an alum, he was a parent,” recalled Bill Gehrman, who attended the school along with Beau and Hunter and was later the director of institutional advancement."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN46",
      "id": "FT46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("College for Joe occurred at the University of Delaware, which he entered in the fall of 1961. He chose political science and history as his majors."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN47",
      "id": "FT47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" There were pranks and hijinks, as he was dinged for using a fire extinguisher on the dorm director."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN48",
      "id": "FT48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Joe joined the football team, as he had done at Archmere. By one account, Joe Sr. made him quit the team after first semester grades were released; in another version of the story, Joe quit to save precious time commuting to see his girlfriend in New York State."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN49",
      "id": "FT49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The University of Delaware was and is a respectable and respected state school, in recent years working to raise its profile, especially in the STEM fields. Its roots trace back to a “free school” founded by a Presbyterian minister named Francis Alison in Chester County, Pennsylvania, in 1743. It moved to Newark and became the Academy of Newark, Newark College, Delaware College and, finally, the University of Delaware in 1921. Women were not permanently admitted until the latter half of the 1800s; a Women’s College was formed in 1914 and was folded fully into the university in 1945.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The university had solid working relationships with Governors Elbert Carvel, who served as a trustee, and Caleb Boggs, who was an alumnus. The school was undergoing massive growth and change during Biden’s time as a student. There were 3,600 undergraduates in 1961, growing to 6,500 by 1967. Women were elected student government presidents in 1957 and 1968. In 1967, the University of Delaware began its two-year “parallel program” in Georgetown, allowing students to save money and transfer north if desired. Student life was still restrictive, however. A dress code and a ban on cars were in place through 1967. Women were not permitted to study in the library while wearing pants, except during exam times."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN50",
      "id": "FT50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joe spent his time plugging away, having fun and dating. He was elected president of his freshman class, beating four other contenders."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN51",
      "id": "FT51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" “He probably never studied as hard as other people did,” said Joe’s freshman year roommate and fellow football player Donald Brunner."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN52",
      "id": "FT52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Biden graduated in 1965, with his plans taking him next to law school.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One thing that never affected Joe was excessive drinking—or drinking of any sort. He was a teetotaler at the University of Delaware and has stayed that way for the rest of his life, seeing alcohol and other chemicals as a “crutch.” Valerie also says she and her siblings all saw the broken hearts and pain that came from alcohol abuse while growing up. “There was nothing good that came from it,” she said. “I believe, as does my brother, that you are genetically predisposed to it; genes will out, so I didn’t want to take the chance.” Beau was similarly inclined; he drank socially but quit at age thirty."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN53",
      "id": "FT53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P25-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The University of Delaware is now home to the Biden School of Public Policy and Administration, located in Graham Hall. "), _c('i', [_vm._v("Dan Shortridge.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1962, Joe took a summer job lifeguarding at a city-run pool in Wilmington, at Prices Run in Brown-Burton-Winchester Park. It was an eye-opening, consciousness-raising experience for Joe, as he was the only white lifeguard in a staff of twelve. His coworkers were all Black, and it was the first time both types of young men had the real opportunity to learn from each other—on the pool deck and on the basketball court. “I was a fascination to everybody at Prices Run,” Joe recalled. Some of the people, he said, had never talked in-depth to a white person."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN54",
      "id": "FT54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was the first time I got to know well and became good friends with all of these inner-city Black guys, all of whom were college students at historically Black colleges,” Joe said. “They’d ask me questions like ‘What do white girls do? Where do you live?’ It was almost like we were exchange students.” One coworker asked him if he owned a five-gallon gasoline can, explaining that it was a necessity when traveling to see relatives in North Carolina, as most gas stations wouldn’t let Black travelers fill up their tanks. These conversations were critical for Joe as he was coming out of white Irish Catholic schools and communities."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN55",
      "id": "FT55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P26-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("During one summer in college, Biden lifeguarded at the Prices Run Pool, which was later named after him. "), _c('i', [_vm._v("Dan Shortridge.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wanted to get more involved,” he said later. “I’d turn on the television and I’d see and listen to Dr. King and others, but I didn’t know any Black people. So, I wanted to work here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the summer of 2017, the city of Wilmington renamed the Prices Run Pool the Joseph R. Biden Jr. Aquatic Center in honor of the former vice president. Biden climbed up into a lifeguard’s chair, spread his arms wide and grinned."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN56",
      "id": "FT56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" “The neighborhood’s always had my back. And God willing, I’ve always had your back, and I’ll always have it as long as I’m around.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN57",
      "id": "FT57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d95bcd08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter2.vue
// module id = 81
// module chunks = 0